<template>
  <article>
    <div class="flex flex-wrap flex-v-center">
      <!--<el-input v-model="filters.title" size="small" style="width: 135px" placeholder="标题"></el-input>-->
      <!--<div class="blue-small-btn ml20" @click="getCardList">搜索</div>-->
      <el-select v-model="filters.market" size="small">
        <el-option :value="10000" label="所有"></el-option>
        <el-option :value="0" label="系统"></el-option>
        <el-option :value="1" label="贝贝家"></el-option>
        <el-option :value="2" label="电商"></el-option>
      </el-select>
      <router-link class="blue-small-btn ml20" :to="{path: 'cardEdit', query: {id: '0'}}">新建</router-link>
    </div>
    <el-table :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="mt20">
      <el-table-column prop="id" label="ID" width=""></el-table-column>
      <el-table-column prop="market" label="模块" width="" :formatter="formatMarket"></el-table-column>
      <el-table-column prop="title" label="标题" width=""></el-table-column>
      <el-table-column prop="status" label="状态" width="" :formatter="formatStatus"></el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120">
        <template slot-scope="scope">
          <div class="flex">
            <router-link :to="{path: 'cardEdit', query: {id: scope.row.id}}" class="blue-small-btn">编辑</router-link>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt36 pb36">
    </el-pagination>
  </article>
</template>

<style>

</style>

<script>
import util from '../../../script/util'
import {getCardList} from '../../../api/api'
export default {
  data () {
    return {
      filters: {
        p: 1,
        l: 20,
        total: 0,
        title: '',
        market: 2
      },
      listLoading: false,
      lists: []
    }
  },
  methods: {
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    handleSizeChange (val) { // 处理每页数
      this.filters.l = val
      this.getCardList()
    },
    handleCurrentChange (val) { // 处理页码
      this.filters.p = val
      this.getCardList()
    },
    getCardList () {
      let market = this.filters.market
      let params = {
        p: this.filters.p,
        l: this.filters.l,
        market: market
      }
      this.listLoading = true
      getCardList(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        }
        this.listLoading = false
      })
    },
    formatMarket (row) {
      return util.formatMarket(Number(row.market))
    },
    formatStatus (row) { // 格式化状态
      switch (row.status) {
        case 0:
          return '隐藏'
        case 1:
          return '正常'
      }
    }
  },
  mounted () {
    this.getCardList()
  },
  watch: {
    'filters.market': 'getCardList'
  }
}
</script>



// WEBPACK FOOTER //
// src/page/function/card/cardList.vue